import { Box, Tabs } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import { useContext } from "react";

import TabElement from "@/components/Requerimiento/TabElement";
import { context } from "@/context/requirementsContext";

const DatosGenerales = dynamic(() => import("./DatosGenerales"));
const DatosInmueble = dynamic(() => import("./DatosInmueble"));
const CaracteristicasTerreno = dynamic(() => import("./CaracteristicasTerreno"));

const Requerimiento = () => {
    const { step, updateStep } = useContext(context);

    return (
        <>
            <Box maxW="6xl" mx="auto" mt="24" color="black">
                <Tabs.Root
                    value={step.toString()}
                    onValueChange={(details) => {
                        updateStep(parseInt(details.value));
                    }}
                    variant="unstyled"
                    minHeight="100px"
                >
                    <Box w="full" mx="auto" position="relative" overflow="hidden">
                        <Tabs.List justifyContent="center" zIndex={1} minW="100%">
                            <Tabs.Trigger
                                value="0"
                                mr="auto"
                                title="Datos Generales"
                                aria-label="Datos Generales sección"
                                _focus={{ border: 0, outline: 0 }}
                                disabled={step < 0}
                                cursor={step >= 0 ? "pointer" : "not-allowed"}
                                height="100%"
                            >
                                <TabElement
                                    currentTabIndex={step}
                                    index={0}
                                    img="https://media.grupoguia.mx/assets/home-page/requerimiento/datos_generales.webp"
                                    fontSize="sm"
                                >
                                    Datos
                                    <br />
                                    Generales
                                </TabElement>
                            </Tabs.Trigger>
                            <Tabs.Trigger
                                value="1"
                                mx="auto"
                                title="Detalles del inmueble"
                                aria-label="Detalles del inmueble sección"
                                _focus={{ border: 0, outline: 0 }}
                                disabled={step < 1}
                                cursor={step >= 1 ? "pointer" : "not-allowed"}
                                height="100%"
                            >
                                <TabElement
                                    currentTabIndex={step}
                                    index={1}
                                    img="https://media.grupoguia.mx/assets/home-page/requerimiento/detalles_inmueble.webp"
                                    bg="#00000"
                                    fontSize="sm"
                                >
                                    Detalles
                                    <br /> del inmueble
                                </TabElement>
                            </Tabs.Trigger>
                            <Tabs.Trigger
                                value="2"
                                ml="auto"
                                title="Carecterísticas del terreno"
                                aria-label="Carecterísticas del terreno sección"
                                _focus={{ border: 0, outline: 0 }}
                                disabled={step < 2}
                                cursor={step >= 2 ? "pointer" : "not-allowed"}
                                height="100%"
                            >
                                <TabElement
                                    currentTabIndex={step}
                                    index={2}
                                    img="https://media.grupoguia.mx/assets/home-page/requerimiento/caracteristicas_terreno.webp"
                                    fontSize="sm"
                                >
                                    Características
                                    <br /> del Terreno
                                </TabElement>
                            </Tabs.Trigger>
                        </Tabs.List>
                        <Box
                            size="sm"
                            position="absolute"
                            h="2"
                            bg="gray.200"
                            w={{ md: "90%", base: "75%" }}
                            mx="auto"
                            left="0"
                            right="0"
                            top={{ base: "30%", md: "35%" }}
                            bottom={{ base: "30%", md: "35%" }}
                            zIndex="0"
                        />
                    </Box>
                    <Tabs.Content value="0">
                        <Box px={{ base: "2", md: "6" }}>
                            <DatosGenerales />
                        </Box>
                    </Tabs.Content>
                    <Tabs.Content value="1">
                        <Box px={{ base: "2", md: "6" }}>
                            <DatosInmueble />
                        </Box>
                    </Tabs.Content>
                    <Tabs.Content value="2">
                        <Box px={{ base: "2", md: "6" }}>
                            <CaracteristicasTerreno />
                        </Box>
                    </Tabs.Content>
                </Tabs.Root>
            </Box>
        </>
    );
};

export default Requerimiento;
